import script from "./TopArea.vue?vue&type=script&lang=ts&setup=true"
export * from "./TopArea.vue?vue&type=script&lang=ts&setup=true"

import "./TopArea.vue?vue&type=style&index=0&id=4cc8b25a&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cc8b25a"]])

export default __exports__